/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/fr/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/fr/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/fr/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/fr/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/fr/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/fr/preview-05.webp'),
    },
  ],
};
